// extracted by mini-css-extract-plugin
module.exports = {"theme-dark":"_3JMRW","themeDark":"_3JMRW","theme-light":"_1HdmX","themeLight":"_1HdmX"};